module.exports = __webpack_public_path__ + "f78fd496b0b57e2adfd800319cb73b72.jpg";